import React, { useEffect } from "react";
import { handleEvent } from "util/user-events";

export const useUpsellVisible = (): boolean => {
    return true;
};

interface UpsellBannerProps {
    source: string;
    children: React.ReactNode;
}

export const UpsellBanner: React.FC<UpsellBannerProps> = props => {
    const visible = useUpsellVisible();
    const { source } = props;

    useEffect(() => {
        if (visible) {
            handleEvent("premium-callout", { source });
        }
    }, [visible, source]);

    if (!visible) {
        return null;
    }

    return <>{props.children}</>;
};
